export default __webpack_public_path__ + "static/media/i-attention.a5ac8860.svg";